import type { RegentsQuestion } from './regentsTest1';

export const regentsTest3: RegentsQuestion[] = [
  {
    id: 1,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Equations with Variables on Both Sides',
    standard: 'A-REI.B.3',
    question: 'Solve: 4x + 3 = 2x + 11',
    options: ['x = 4', 'x = 7', 'x = 2', 'x = 8'],
    correctAnswer: 0,
    solution: [
      'Subtract 2x from both sides: 2x + 3 = 11',
      'Subtract 3 from both sides: 2x = 8',
      'Divide by 2: x = 4'
    ]
  },
  {
    id: 2,
    type: 'multiple-choice',
    points: 2,
    topic: 'Multiplying Polynomials',
    standard: 'A-APR.A.1',
    question: 'Expand: (2x − 3)²',
    options: ['4x² − 9', '4x² − 12x + 9', '4x² + 12x + 9', '4x² − 6x + 9'],
    correctAnswer: 1,
    solution: [
      'Use the perfect square formula: (a − b)² = a² − 2ab + b²',
      'a = 2x, b = 3',
      '(2x)² − 2(2x)(3) + 3² = 4x² − 12x + 9'
    ]
  },
  {
    id: 3,
    type: 'multiple-choice',
    points: 2,
    topic: 'Domain of a Function',
    standard: 'F-IF.B.5',
    question: 'What is the domain of f(x) = √(x − 4)?',
    options: ['x ≥ 4', 'x > 4', 'x ≤ 4', 'All real numbers'],
    correctAnswer: 0,
    solution: [
      'The expression under a square root must be ≥ 0',
      'x − 4 ≥ 0',
      'x ≥ 4',
      'Domain: x ≥ 4 or [4, ∞)'
    ]
  },
  {
    id: 4,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Systems by Elimination',
    standard: 'A-REI.C.6',
    question: 'Solve: 3x + 2y = 14 and 3x − 2y = 4. What is x?',
    options: ['x = 2', 'x = 3', 'x = 4', 'x = 5'],
    correctAnswer: 1,
    solution: [
      'Add the two equations to eliminate y:',
      '(3x + 2y) + (3x − 2y) = 14 + 4',
      '6x = 18',
      'x = 3'
    ]
  },
  {
    id: 5,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quadratic Formula — Discriminant',
    standard: 'A-REI.B.4',
    question: 'For x² + 2x + 5 = 0, the discriminant is −16. This means:',
    options: [
      'Two real solutions',
      'One real solution',
      'No real solutions',
      'Infinitely many solutions'
    ],
    correctAnswer: 2,
    solution: [
      'The discriminant is b² − 4ac',
      'If discriminant > 0: two distinct real solutions',
      'If discriminant = 0: one real solution (double root)',
      'If discriminant < 0: no real solutions (complex roots)',
      'Since discriminant = −16 < 0: no real solutions'
    ]
  },
  {
    id: 6,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Slope',
    standard: 'S-ID.C.7',
    question: 'A linear model shows that for every additional year of education, income increases by $3,500. What is the slope?',
    options: ['3,500', '−3,500', '1', '0'],
    correctAnswer: 0,
    solution: [
      'Slope = rate of change = change in y per unit change in x',
      'For every 1 year increase in education (x), income (y) increases by $3,500',
      'Slope = 3,500'
    ]
  },
  {
    id: 7,
    type: 'multiple-choice',
    points: 2,
    topic: 'Factoring — GCF',
    standard: 'A-SSE.A.2',
    question: 'Factor completely: 6x³ − 9x² + 3x',
    options: ['3x(2x² − 3x + 1)', '3(2x³ − 3x² + x)', 'x(6x² − 9x + 3)', '3x(2x − 1)(x − 1)'],
    correctAnswer: 3,
    solution: [
      'Find the GCF: GCF of 6x³, 9x², 3x is 3x',
      'Factor out 3x: 3x(2x² − 3x + 1)',
      'Factor the trinomial 2x² − 3x + 1: find factors of 2×1=2 that add to −3: −2 and −1',
      '3x(2x − 1)(x − 1)'
    ]
  },
  {
    id: 8,
    type: 'multiple-choice',
    points: 2,
    topic: 'Exponential Functions',
    standard: 'F-LE.B.5',
    question: 'In the function P = 1200(1.05)^t, what does 1.05 represent?',
    options: [
      'The initial population',
      'The time in years',
      'A 5% annual growth rate',
      'A 5% annual decay rate'
    ],
    correctAnswer: 2,
    solution: [
      'In P = P₀(1 + r)^t, the base (1 + r) is the growth factor',
      '1.05 = 1 + 0.05',
      'r = 0.05 = 5%',
      'Since r > 0, this is a 5% annual growth rate'
    ]
  },
  {
    id: 9,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Inequalities',
    standard: 'A-REI.B.3',
    question: 'Solve: 3 − 4x ≤ 15',
    options: ['x ≥ −3', 'x ≤ −3', 'x ≥ 3', 'x ≤ 3'],
    correctAnswer: 0,
    solution: [
      'Subtract 3 from both sides: −4x ≤ 12',
      'Divide by −4 and flip the inequality sign: x ≥ −3',
      'Solution: x ≥ −3'
    ]
  },
  {
    id: 10,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quadratic Functions — Vertex',
    standard: 'F-IF.C.7',
    question: 'What is the minimum value of f(x) = 2x² − 8x + 5?',
    options: ['−3', '2', '5', '−8'],
    correctAnswer: 0,
    solution: [
      'Find the x-coordinate of the vertex: x = −b/(2a) = 8/(2×2) = 2',
      'Substitute x = 2: f(2) = 2(4) − 8(2) + 5 = 8 − 16 + 5 = −3',
      'Since a = 2 > 0, the parabola opens upward, so this is a minimum',
      'Minimum value: −3'
    ]
  },
  {
    id: 11,
    type: 'multiple-choice',
    points: 2,
    topic: 'Rational Exponents',
    standard: 'N-RN.A.2',
    question: 'Simplify: (16x⁴)^(3/4)',
    options: ['8x³', '12x³', '4x³', '8x⁴'],
    correctAnswer: 0,
    solution: [
      'Apply the exponent to each factor: 16^(3/4) × (x⁴)^(3/4)',
      '16^(3/4) = (⁴√16)³ = 2³ = 8',
      '(x⁴)^(3/4) = x^(4 × 3/4) = x³',
      'Answer: 8x³'
    ]
  },
  {
    id: 12,
    type: 'multiple-choice',
    points: 2,
    topic: 'Data Distribution',
    standard: 'S-ID.A.3',
    question: 'A data set has mean = 50 and median = 35. The distribution is most likely:',
    options: ['Symmetric', 'Skewed left', 'Skewed right', 'Uniform'],
    correctAnswer: 2,
    solution: [
      'When mean > median, the distribution is skewed right (positively skewed)',
      'High outliers pull the mean to the right',
      'Mean = 50 > Median = 35, so the distribution is skewed right',
      'Answer: Skewed right'
    ]
  },
  {
    id: 13,
    type: 'multiple-choice',
    points: 2,
    topic: 'Writing Equations from Two Points',
    standard: 'A-CED.A.2',
    question: 'What is the equation of the line through (0, 3) and (2, 7)?',
    options: ['y = 2x + 3', 'y = 3x + 2', 'y = 4x + 3', 'y = 2x + 7'],
    correctAnswer: 0,
    solution: [
      'Find slope: m = (7 − 3)/(2 − 0) = 4/2 = 2',
      'The y-intercept is 3 (since the line passes through (0, 3))',
      'Equation: y = 2x + 3'
    ]
  },
  {
    id: 14,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Quadratics — Square Root Method',
    standard: 'A-REI.B.4',
    question: 'Solve: (x + 5)² = 36',
    options: ['x = 1 or x = −11', 'x = 6 or x = −6', 'x = 31 or x = −41', 'x = 1 or x = 11'],
    correctAnswer: 0,
    solution: [
      'Take the square root of both sides: x + 5 = ±6',
      'Case 1: x + 5 = 6 → x = 1',
      'Case 2: x + 5 = −6 → x = −11',
      'Solutions: x = 1 or x = −11'
    ]
  },
  {
    id: 15,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Intercepts',
    standard: 'F-IF.B.4',
    question: 'The function C(n) = 5n + 20 models the cost of n items. What does the y-intercept 20 represent?',
    options: [
      'The cost per item',
      'The number of items',
      'A fixed starting cost regardless of items purchased',
      'The maximum number of items'
    ],
    correctAnswer: 2,
    solution: [
      'The y-intercept is the value of C when n = 0',
      'C(0) = 5(0) + 20 = 20',
      'This is the cost when no items are purchased — a fixed fee',
      'Answer: A fixed starting cost regardless of items purchased'
    ]
  },
  {
    id: 16,
    type: 'multiple-choice',
    points: 2,
    topic: 'Polynomial Subtraction',
    standard: 'A-APR.A.1',
    question: 'Subtract: (5x² − 3x + 2) − (2x² + x − 4)',
    options: ['3x² − 4x + 6', '3x² − 2x + 6', '7x² − 2x − 2', '3x² − 4x − 2'],
    correctAnswer: 0,
    solution: [
      'Distribute the negative: 5x² − 3x + 2 − 2x² − x + 4',
      'Combine x² terms: 5x² − 2x² = 3x²',
      'Combine x terms: −3x − x = −4x',
      'Combine constants: 2 + 4 = 6',
      'Answer: 3x² − 4x + 6'
    ]
  },
  {
    id: 17,
    type: 'multiple-choice',
    points: 2,
    topic: 'Comparing Linear and Exponential Growth',
    standard: 'F-LE.A.3',
    question: 'Function A: f(x) = 100x. Function B: g(x) = 2^x. For large values of x, which is greater?',
    options: ['f(x) = 100x', 'g(x) = 2^x', 'They are always equal', 'Cannot be determined'],
    correctAnswer: 1,
    solution: [
      'Linear functions grow at a constant rate',
      'Exponential functions eventually grow faster than any linear function',
      'For large x, 2^x will far exceed 100x',
      'Example: x = 100: f(100) = 10,000 but g(100) = 2^100 ≈ 1.27 × 10^30',
      'Answer: g(x) = 2^x'
    ]
  },
  {
    id: 18,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Systems — No Solution',
    standard: 'A-REI.C.6',
    question: 'The system y = 3x + 2 and y = 3x − 5 has:',
    options: ['One solution', 'No solution', 'Infinitely many solutions', 'Two solutions'],
    correctAnswer: 1,
    solution: [
      'Both lines have slope m = 3 (parallel lines)',
      'They have different y-intercepts (2 and −5)',
      'Parallel lines never intersect',
      'Answer: No solution'
    ]
  },
  {
    id: 19,
    type: 'multiple-choice',
    points: 2,
    topic: 'Factoring — Perfect Square Trinomial',
    standard: 'A-SSE.A.2',
    question: 'Which is a perfect square trinomial?',
    options: ['x² + 6x + 9', 'x² + 6x + 8', 'x² + 5x + 9', 'x² + 6x − 9'],
    correctAnswer: 0,
    solution: [
      'A perfect square trinomial has the form a² + 2ab + b²',
      'x² + 6x + 9: check if 9 = (6/2)² = 3² = 9 ✓',
      'x² + 6x + 9 = (x + 3)²',
      'Answer: x² + 6x + 9'
    ]
  },
  {
    id: 20,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quantitative Reasoning',
    standard: 'N-Q.A.3',
    question: 'A student measures a table as 1.8 meters. Which is the most appropriate level of accuracy?',
    options: ['1.8 m (nearest tenth)', '1.80000 m (6 decimal places)', '2 m (nearest meter)', '1.83 m (nearest hundredth)'],
    correctAnswer: 0,
    solution: [
      'Accuracy should match the precision of the measuring tool',
      'A standard ruler measures to the nearest centimeter (0.01 m) or tenth of a meter',
      '1.8 m (nearest tenth) is appropriate for measuring a table',
      'Too many decimal places imply false precision'
    ]
  },
  {
    id: 21,
    type: 'multiple-choice',
    points: 2,
    topic: 'Rate of Change',
    standard: 'F-IF.B.6',
    question: 'The table shows: x = 0, 2, 4, 6 and y = 3, 7, 11, 15. What is the average rate of change?',
    options: ['1', '2', '3', '4'],
    correctAnswer: 1,
    solution: [
      'Average rate of change = (change in y) / (change in x)',
      'From x = 0 to x = 6: Δy = 15 − 3 = 12, Δx = 6 − 0 = 6',
      'Rate of change = 12/6 = 2',
      'Answer: 2'
    ]
  },
  {
    id: 22,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Literal Equations',
    standard: 'A-CED.A.4',
    question: 'Solve for h in V = (1/3)πr²h',
    options: ['h = 3V/(πr²)', 'h = V/(3πr²)', 'h = 3Vπr²', 'h = V/(πr²)'],
    correctAnswer: 0,
    solution: [
      'Multiply both sides by 3: 3V = πr²h',
      'Divide both sides by πr²: h = 3V/(πr²)',
      'Answer: h = 3V/(πr²)'
    ]
  },
  {
    id: 23,
    type: 'multiple-choice',
    points: 2,
    topic: 'Scatter Plot Interpretation',
    standard: 'S-ID.B.6',
    question: 'A scatter plot of study hours vs. test scores shows a strong positive correlation. A student studies 0 hours. Based on the trend, their score would likely be:',
    options: ['Very high', 'Average', 'Low', 'Cannot be predicted'],
    correctAnswer: 2,
    solution: [
      'A strong positive correlation means more study hours → higher scores',
      'Fewer study hours → lower scores',
      '0 hours of study would predict a low score',
      'Answer: Low'
    ]
  },
  {
    id: 24,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Quadratics — Factoring',
    standard: 'A-REI.B.4',
    question: 'Solve: 3x² − 12x = 0',
    options: ['x = 0 or x = 4', 'x = 4 only', 'x = 0 only', 'x = 3 or x = 4'],
    correctAnswer: 0,
    solution: [
      'Factor out the GCF: 3x(x − 4) = 0',
      'Set each factor equal to zero:',
      '3x = 0 → x = 0',
      'x − 4 = 0 → x = 4',
      'Solutions: x = 0 or x = 4'
    ]
  },
  {
    id: 25,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Expressions',
    standard: 'A-SSE.A.1',
    question: 'In the expression 50 + 12w, if w represents weeks, what does 12w represent?',
    options: [
      'The starting amount',
      'The total amount after w weeks',
      'The amount added each week',
      'The number of weeks'
    ],
    correctAnswer: 2,
    solution: [
      '50 is the constant (starting amount)',
      '12w means 12 is multiplied by w (weeks)',
      '12 is the rate — the amount added each week',
      'Answer: The amount added each week'
    ]
  },
  {
    id: 26,
    type: 'multiple-choice',
    points: 2,
    topic: 'Graphing Systems',
    standard: 'A-REI.D.11',
    question: 'The graphs of y = x + 2 and y = −x + 6 intersect at:',
    options: ['(2, 4)', '(4, 2)', '(1, 5)', '(3, 3)'],
    correctAnswer: 0,
    solution: [
      'Set equal: x + 2 = −x + 6',
      '2x = 4',
      'x = 2',
      'y = 2 + 2 = 4',
      'Intersection: (2, 4)'
    ]
  },
  {
    id: 27,
    type: 'multiple-choice',
    points: 2,
    topic: 'Increasing and Decreasing Functions',
    standard: 'F-IF.B.4',
    question: 'For f(x) = −x² + 4x − 1, on which interval is the function increasing?',
    options: ['x < 2', 'x > 2', 'x < −2', 'All real numbers'],
    correctAnswer: 0,
    solution: [
      'Find the vertex: x = −b/(2a) = −4/(2×−1) = 2',
      'Since a = −1 < 0, the parabola opens downward',
      'The function increases to the left of the vertex and decreases to the right',
      'Increasing on x < 2'
    ]
  },
  {
    id: 28,
    type: 'multiple-choice',
    points: 2,
    topic: 'Arithmetic Sequences as Linear Functions',
    standard: 'F-LE.A.2',
    question: 'An arithmetic sequence has first term 7 and common difference 4. Which function represents the nth term?',
    options: ['f(n) = 4n + 3', 'f(n) = 7n + 4', 'f(n) = 4n + 7', 'f(n) = 7 + 4n'],
    correctAnswer: 0,
    solution: [
      'The nth term of an arithmetic sequence: aₙ = a₁ + (n − 1)d',
      'aₙ = 7 + (n − 1)(4) = 7 + 4n − 4 = 4n + 3',
      'Check n = 1: f(1) = 4(1) + 3 = 7 ✓',
      'Check n = 2: f(2) = 4(2) + 3 = 11 = 7 + 4 ✓'
    ]
  },
  {
    id: 29,
    type: 'multiple-choice',
    points: 2,
    topic: 'Irrational Numbers',
    standard: 'N-RN.B.3',
    question: 'Between which two consecutive integers does √55 lie?',
    options: ['6 and 7', '7 and 8', '8 and 9', '5 and 6'],
    correctAnswer: 1,
    solution: [
      '7² = 49 and 8² = 64',
      'Since 49 < 55 < 64, we have √49 < √55 < √64',
      '7 < √55 < 8',
      'Answer: between 7 and 8'
    ]
  },
  {
    id: 30,
    type: 'multiple-choice',
    points: 2,
    topic: 'Two-Way Tables',
    standard: 'S-ID.B.5',
    question: 'A two-way table shows 120 students: 70 play sports, 50 do not. Of those who play sports, 40 are boys. What percent of sports players are boys?',
    options: ['33%', '40%', '57%', '67%'],
    correctAnswer: 2,
    solution: [
      'Total sports players = 70',
      'Boys who play sports = 40',
      'Percent = 40/70 × 100 ≈ 57.1%',
      'Answer: approximately 57%'
    ]
  }
];
